module.exports = __webpack_public_path__ + "static/img/tooltip-sma-top-bottom-margin.6a803d9.png";